var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Inject } from '../Application';
import { Constants, Events } from '../Contract';
import { ErrorCodes, ExceptionHandlerClass } from '../System/Aop';
var ChangeNotifier = (function () {
    function ChangeNotifier(inject) {
        if (inject === void 0) { inject = null; }
        this.inject = inject || Inject.Instance;
        this.event = this.inject.resolve(Constants.EventAggregator);
    }
    ChangeNotifier.prototype.apply = function (model) {
        var _this = this;
        model['__onchange'] = function (property) {
            if (!model.isCoreSynchronizing()) {
                _this.event.publish(Events.Change, { model: model, property: property });
            }
        };
    };
    ChangeNotifier = __decorate([
        ExceptionHandlerClass(ErrorCodes.ClientCore),
        __metadata("design:paramtypes", [Object])
    ], ChangeNotifier);
    return ChangeNotifier;
}());
export { ChangeNotifier };
